export default (client) => {
  return {
    listKits() {
      return client.get('/vokalis/solution-kits/')
    },
    deployKit(
      kitId,
      { workspaceId, workspaceName, userWebSocketId, notifyVokalis = false }
    ) {
      const payload = {}
      if (workspaceId) {
        payload.workspace_id = workspaceId
      }
      if (workspaceName) {
        payload.workspace_name = workspaceName
      }
      if (userWebSocketId) {
        payload.user_websocket_id = userWebSocketId
      }
      if (notifyVokalis) {
        payload.notify_vokalis = true
      }
      return client.post(`/vokalis/solution-kits/${kitId}/deploy/`, payload)
    },
    getInstallationByJob(jobId) {
      return client.get(
        `/vokalis/solution-kit-installations/by-job/${jobId}/`
      )
    },
    listWorkspaceInstallations(workspaceId) {
      return client.get(
        `/vokalis/workspaces/${workspaceId}/solution-kit-installations/`
      )
    },
    listKitWorkspaces(kitId) {
      return client.get(`/vokalis/solution-kits/${kitId}/workspaces/`)
    },
    uninstallInstallation(installationId) {
      return client.delete(
        `/vokalis/solution-kit-installations/${installationId}/`
      )
    },
    getInstallation(installationId) {
      return client.get(
        `/vokalis/solution-kit-installations/${installationId}/`
      )
    },
    getInstallationKanbanConfig(installationId, viewId) {
      return client.get(
        `/vokalis/solution-kit-installations/${installationId}/kanban/${encodeURIComponent(
          viewId
        )}/config/`
      )
    },
    getInstallationCalendarConfig(installationId, viewId) {
      return client.get(
        `/vokalis/solution-kit-installations/${installationId}/calendar/${encodeURIComponent(
          viewId
        )}/config/`
      )
    },
    getInstallationTimelineConfig(installationId, viewId) {
      return client.get(
        `/vokalis/solution-kit-installations/${installationId}/timeline/${encodeURIComponent(
          viewId
        )}/config/`
      )
    },
    getInstallationTimelineRows(installationId, viewId, params = {}) {
      return client.get(
        `/vokalis/solution-kit-installations/${installationId}/timeline/${encodeURIComponent(
          viewId
        )}/rows/`,
        { params }
      )
    },
  }
}

